import { useState } from "react"
import ChatBox from "./ChatBox"
import { FiSend, FiSettings, FiUpload } from "react-icons/fi"
import { useModal } from "@/contexts/ModalContext"
import { LuAudioLines } from "react-icons/lu"

import languages from "@/constants/languages"
import FilePicker from "./ui/FilePicker"
import {Input} from "./ui/shadcn/input"
import {Textarea} from "./ui/shadcn/textarea"
import VoiceSettingsModal from '@/components/modals/VoiceSettingsModal'
import Button from "./ui/Button"

export default function CharacterEditor({ defaultValue, show, onChange }) {
    const {openModal} = useModal()
    const [character, setCharacter] = useState(defaultValue || {
        name: 'New Character',
        description: '',
        voice_ids: []
    })

    const handleChange = (e) => {
        const newCharacter = {...character, [e.target.name]: e.target.value}
        setCharacter(newCharacter)
        if(onChange) onChange(newCharacter)
    }

    const handleVoiceChange = (e) => {
        const newCharacter = {...character}
        if(!newCharacter.voice_ids.find(v => v.language === e.target.name)){
            newCharacter.voice_ids.push({language: e.target.name, voice_id: e.target.value})
        } else {
            newCharacter.voice_ids = newCharacter.voice_ids.map(v => v.language === e.target.name ? {...v, voice_id: e.target.value} : v) 
        }
        setCharacter(newCharacter)
        if(onChange) onChange(newCharacter)
    }

    const handleFileSelect = (file) => {
        setCharacter(prev => ({...prev, thumbnail_file : file}))
        if(onChange) onChange({...character, thumbnail_file: file})
    }

    const handleVoiceSettings = async () => {
        const voiceSettings = await openModal(<VoiceSettingsModal voiceSettings={character.voice_settings} saveTitle='Ok' />)
        if(!voiceSettings)return
        setCharacter(prev => ({...prev, voice_settings: voiceSettings}))
        if(onChange) onChange({...character, voice_settings: voiceSettings})
    }

    return (
        <div className='flex flex-col gap-4 w-full h-full p-4 overflow-y-auto'>
            <div className='flex flex-col gap-2'>
                <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                <Input type="text" id="name" name="name" defaultValue={character.name} onChange={handleChange} />
            </div>
            <div className='flex flex-col gap-2'>
                <label className="text-xs text-secondary-foreground">Image</label>
                
                <FilePicker className='w-full aspect-video bg-background' preview={character?.thumbnail_url} type='image' onChange={handleFileSelect} accept="image/*" label="Upload Image" icon={<FiUpload className="w-4 h-4" />} />
            </div>
            <div className='flex flex-col gap-2'>
                <label htmlFor="description" className='text-xs text-secondary-foreground'>Description</label>
                <Textarea id="description" name="description" defaultValue={character.description} onChange={handleChange} />
            </div>

            <span className='text-lg py-2 text-secondary-foreground border-t '>Voices</span>
            <label htmlFor={`lang-${show.language}`} className='text-xs text-secondary-foreground'>{languages.find(l=>l.code===show.language)?.name || show.language}</label>
            <div className='flex items-center gap-2'>
                <Input id={`lang-${show.language}`} className='flex-1' name={`${show.language}`} defaultValue={character.voice_ids?.find(v => v.language === show.language)?.voice_id} onChange={handleVoiceChange} />
                <Button type='secondary' icon={<LuAudioLines className='w-4 h-4' />} onClick={handleVoiceSettings} />
            </div>
        </div>
    )
}